<template>
  <div class="mx-auto py-4">
    <div style="display: flex; justify-content: right; padding-right: 2%; background-color: #efefef !important;">
      <v-switch v-model="reportCategory" :label="
        `Report Type: ${ reportCategory === true
          ? 'Summary Report'
          : 'Detail Report'
        }`
      " class="black--text"></v-switch>
    </div>
    <v-card v-if="reportCategory === true" class="mx-4 my-2" flat>
      <v-card-title>
        Pre Service Summary Report
        <v-spacer></v-spacer>
        <div class="ml-12">
          <download-excel v-if="$can('preservice-report', 'export')" :data="cat2Selected" :fields="cat2_export_fields" name="PreServiceSummaryReport.xls"
                          type="csv">
            <v-btn class="teal white--text" color="primary" dark depressed small>
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>

      </v-card-title>
      <v-data-table
          v-model="cat2Selected"
          :headers="cat2Headers" :items="preServiceSummaryReports.rows"
          :loading="cat2loading"
          :options.sync="cat2options"
          :server-items-length="preServiceSummaryReports.count"
          class="elevation-1"
          item-key="id"
          loading-text="Loading... please wait"
          show-select
      >
        <template v-slot:top>
          <v-layout class="p-3" row wrap>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="cat2preServiceLevelValue"
                  :clearable="clearable"
                  :items="PRE_SERVICE_LEVELS"
                  :loading="lookupLoading"
                  item-text="displayName"
                  item-value="name"
                  label="Pre Service Level"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs3>
              <v-autocomplete
                  v-model="cat2universityValue"
                  :clearable="!isUniversityScopedUser && clearable"
                  :disabled="isUniversityScopedUser"
                  :items="UNIVERSITIES"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Higher Learning Institution"
                  return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs3>
              <v-autocomplete
                  v-model="cat2programValue"
                  :clearable="clearable"
                  :items="EDUCATIONAL_PROGRAMS"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Program Education Type"
                  return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="cat2disciplineValue"
                  :clearable="clearable"
                  :items="DISCIPLINES"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Discipline"
                  return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="cat2yearOfEducValue"
                  :clearable="clearable"
                  :items="YEAR_OF_EDUCATION"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Year of Education"
                  return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-layout class="p-3" row wrap>
                <v-flex xs7>
                  <v-text-field
                      v-model="maleValue"
                      label="Unique Male Students"
                      type="number"
                  ></v-text-field
                  >
                </v-flex>
                <v-flex style="margin-top: 10px" xs5>
                  <v-select
                      v-model="maleComparisonValue"
                      :items="comparisons"
                      class="comparisonSelect"
                      dense
                      item-text="name"
                      item-value="value"
                      solo
                  ></v-select
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-layout class="p-3" row wrap>
                <v-flex xs7>
                  <v-text-field
                      v-model="femaleValue"
                      label="Unique Female Students"
                      type="number"
                  ></v-text-field
                  >
                </v-flex>
                <v-flex style="margin-top: 10px" xs5>
                  <v-select
                      v-model="femaleComparisonValue"
                      :items="comparisons"
                      class="comparisonSelect"
                      dense
                      item-text="name"
                      item-value="value"
                      solo
                  ></v-select
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-select
                  v-model="cat2DateRangePreset"
                  :items="dateRangePresets"
                  item-text="text"
                  item-value="value"
                  clearable
                  label="Quick Range"
              ></v-select>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-select
                  v-model="cat2DateRangeYear"
                  :items="dateRangeYears"
                  clearable
                  label="Year"
              ></v-select>
            </v-flex>
            <v-flex v-if="cat2DateRangePreset && cat2DateRangePreset !== 'yearly'" class="p-2" xs2>
              <v-select
                  v-model="cat2DateRangePeriod"
                  :items="getPresetPeriodOptions(cat2DateRangePreset)"
                  :disabled="!cat2DateRangePreset || cat2DateRangePreset === 'yearly'"
                  clearable
                  label="Period"
              ></v-select>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-menu
                  ref="cat2StartMenu"
                  v-model="cat2StartMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="cat2StartDateValue"
                      :clearable="true"
                      persistent-hint
                      placeholder="Start Date"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="cat2StartDateValue"
                    no-title
                    scrollable
                    @input="cat2StartMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-menu
                  ref="cat2EndMenu"
                  v-model="cat2EndMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="cat2EndDateValue"
                      :clearable="true"
                      persistent-hint
                      placeholder="End Date"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="cat2EndDateValue"
                    no-title
                    scrollable
                    @input="cat2EndMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout
          >
        </template>
        <template v-slot:[`item.preServiceLevel`]="{ item }">
          {{ formatPreServiceLevel(item.preServiceLevel) }}
        </template>
      </v-data-table>
    </v-card>
    <v-card v-else class="mx-4 my-2" flat>
      <v-card-title>
        Pre Service Detail Report
        <v-spacer></v-spacer>

        <div class="ml-12">
          <download-excel v-if="$can('preservice-report', 'export')" :data="selected" :fields="export_fields" name="PreServiceDetailReport.xls" type="csv">
            <v-btn class="teal white--text" color="primary" dark depressed small>
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>
      </v-card-title>
      <v-data-table
          v-model="selected"
          :headers="headers" :items="preServiceDetailReports.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="preServiceDetailReports.count"
          class="elevation-1"
          item-key="id"
          loading-text="Loading... please wait"
          show-select>
        <template v-slot:top>
          <v-layout class="pb-2 px-4" row wrap>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="preServiceLevelValue"
                  :clearable="clearable"
                  :items="PRE_SERVICE_LEVELS"
                  :loading="lookupLoading"
                  item-text="displayName"
                  item-value="name"
                  label="Pre Service Level"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="universityValue"
                  :clearable="!isUniversityScopedUser && clearable"
                  :disabled="isUniversityScopedUser"
                  :items="UNIVERSITIES"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Higher Learning Institution"
                  return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="levelOfStudyValue"
                  :clearable="clearable"
                  :items="LEVEL_OF_STUDIES"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Level Of Study"
                  return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="programValue"
                  :clearable="clearable"
                  :items="EDUCATIONAL_PROGRAMS"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Program Education Type"
                  return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="disciplineValue"
                  :clearable="clearable"
                  :items="DISCIPLINES"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Discipline"
                  return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="yearOfEducValue"
                  :clearable="clearable"
                  :items="YEAR_OF_EDUCATION"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Year of Education"
                  return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-text-field
                  v-model="nameValue"
                  hide-details
                  label="Name"
                  single-line
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs1>
              <v-autocomplete
                  v-model="sexValue"
                  :clearable="clearable"
                  :items="GENDERS"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="name"
                  label="Gender"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs1>
              <v-text-field
                  v-model="idNoValue"
                  hide-details
                  label="National ID (FAN)"
                  single-line
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-text-field
                  v-model="departmentValue"
                  hide-details
                  label="Department / Discipline"
                  single-line
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-text-field
                  v-model="backgroundProfessionValue"
                  hide-details
                  label="Background Profession"
                  single-line
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-text-field
                  v-model="nationalityValue"
                  hide-details
                  label="Nationality"
                  single-line
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-select
                  v-model="dateRangePreset"
                  :items="dateRangePresets"
                  item-text="text"
                  item-value="value"
                  clearable
                  label="Quick Range"
              ></v-select>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-select
                  v-model="dateRangeYear"
                  :items="dateRangeYears"
                  clearable
                  label="Year"
              ></v-select>
            </v-flex>
            <v-flex v-if="dateRangePreset && dateRangePreset !== 'yearly'" class="p-2" xs2>
              <v-select
                  v-model="dateRangePeriod"
                  :items="getPresetPeriodOptions(dateRangePreset)"
                  :disabled="!dateRangePreset || dateRangePreset === 'yearly'"
                  clearable
                  label="Period"
              ></v-select>
            </v-flex>
            <v-flex class="p-2" xs1>
              <v-menu ref="menu" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="startDateValue" :clearable="true" persistent-hint
                                placeholder="Start Date" prepend-icon="mdi-calendar" v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    v-model="startDateValue"
                    no-title
                    scrollable
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="p-2" xs1>
              <v-menu ref="menu" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="endDateValue" :clearable="true" persistent-hint
                                placeholder="End Date" prepend-icon="mdi-calendar" v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    v-model="endDateValue"
                    no-title
                    scrollable
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </template>
        <template v-slot:[`item.pre_student_statuses`]="{ item }">
          <label v-if="item.pre_student_statuses && item.pre_student_statuses.length !== 0" for="item">
            <span
                v-for="(status, index) in item.pre_student_statuses"
                :key="index"
                style="display: flex"
            >
              {{ status.yearOfEducation ? status.yearOfEducation : "-" }}({{
                status.studentStatus ? status.studentStatus : "-"
              }}, {{ getDisplayCumulativeGpa(status) }})
              <span v-if="index !== item.pre_student_statuses.length - 1">,</span>
            </span>
          </label>
          <label v-else for="item">-</label>
        </template>
        <template v-slot:[`item.preServiceLevel`]="{ item }">
          {{ formatPreServiceLevel(item.preServiceLevel) }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {getAssignedUniversityOption, getDisciplines, getEducationalPrograms, getLevelOfStudies, getUniversities, isUniversityScopedPreserviceUser} from "@/utils/helper";
import {PreServiceReportService} from "./pre-service-report-service";
import {EducLevelEnum, YearOfEducEnum} from "@/utils/enums";
import reportDateRangeMixin from "@/mixins/reportDateRangeMixin";

export default {
  mixins: [reportDateRangeMixin],
  computed: {
    isUniversityScopedUser() {
      return isUniversityScopedPreserviceUser();
    },
  },
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      preServiceDetailReports: [],
      headers: [
        {text: "Name", value: "fullName"},
        {text: "Sex", value: "sex"},
        {text: "National ID (FAN)", value: "idNo"},
        {text: "Program Education Type", value: "educationProgram.name"},
        {text: "Department / Discipline", value: "discipline.name"},
        {text: "Background Profession", value: "backgroundProfession"},
        {text: "Level Of Study", value: "levelOfStudy.name"},
        {text: "Pre Service Level", value: "preServiceLevel"},
        {text: "Higher Learning Institution", value: "university.name"},
        {text: "Year of Entry", value: "entryYear"},
        {text: "Expected Graduation Year", value: "expectedYear"},
        {text: "Student Status / Cumulative GPA", value: "pre_student_statuses"},
      ],
      export_fields: {
        "Name": "fullName",
        "Sex": "sex",
        "National ID (FAN)": "idNo",
        "Program Education Type": "educationProgram.name",
        "Department / Discipline": "discipline.name",
        "Background Profession": "backgroundProfession",
        "Level Of Study": "levelOfStudy.name",
        "Pre Service Level": {
          field: "preServiceLevel",
          callback: (value) => this.formatPreServiceLevel(value),
        },
        "Higher Learning Institution": "university.name",
        "Year of Entry": "entryYear",
        "Expected Graduation Year": "expectedYear",
        "Student Status / Cumulative GPA": {
          field: "pre_student_statuses",
          callback: (value) => this.formatStudentStatuses(value),
        },
      },
      selected: [],

      cat2options: {
        page: 1,
        itemsPerPage: 10,
      },
      preServiceSummaryReports: [],
      cat2Headers: [
        {text: "Higher Learning Institution", value: "university.name"},
        {text: "Pre Service Level", value: "preServiceLevel"},
        {text: "Program Education Type", value: "educationProgram.name"},
        {text: "Discipline", value: "discipline.name"},
        {text: "Year Of Education", value: "entryYear"},
        {text: "Unique Male Students", value: "noOfMale"},
        {text: "Unique Female Students", value: "noOfFemale"},
        {text: "Unique Students", value: "uniqueStudentCount"},
        {text: "Department Enrolments", value: "enrollmentCount"},
      ],
      cat2_export_fields: {
        "Higher Learning Institution": "university.name",
        "Pre Service Level": {
          field: "preServiceLevel",
          callback: (value) => this.formatPreServiceLevel(value),
        },
        "Program Education Type": "educationProgram.name",
        "Unique Female Students": "noOfFemale",
        "Unique Male Students": "noOfMale",
        "Unique Students": "uniqueStudentCount",
        "Department Enrolments": "enrollmentCount",
      },
      cat2Selected: [],

      reportCategory: true,

      PRE_SERVICE_LEVELS: [],
      UNIVERSITIES: [],
      LEVEL_OF_STUDIES: [],
      EDUCATIONAL_PROGRAMS: [],
      DISCIPLINES: [],
      YEAR_OF_EDUCATION: [],
      GENDERS: [],

      lookupLoading: false,
      clearable: true,
      loading: false,
      cat2loading: false,

      preServiceLevelValue: null,
      universityValue: null,
      levelOfStudyValue: null,
      programValue: null,
      disciplineValue: null,
      yearOfEducValue: null,
      departmentValue: null,
      backgroundProfessionValue: null,
      withdrawnValue: null,
      nameValue: null,
      sexValue: null,
      idNoValue: null,
      nationalityValue: null,
      startDateValue: null,
      endDateValue: null,
      dateRangePreset: null,
      dateRangeYear: null,
      dateRangePeriod: null,

      currentYear: new Date().getFullYear(),

      cat2preServiceLevelValue: null,
      cat2universityValue: null,
      cat2programValue: null,
      cat2disciplineValue: null,
      cat2yearOfEducValue: null,
      cat2StartDateValue: null,
      cat2EndDateValue: null,
      cat2StartMenu: false,
      cat2EndMenu: false,
      cat2DateRangePreset: null,
      cat2DateRangeYear: null,
      cat2DateRangePeriod: null,
      maleValue: null,
      femaleValue: null,
      comparisons: [
        {name: "=", value: "eq"},
        {name: "<", value: "lt"},
        {name: ">", value: "gt"},
        {name: "<=", value: "lte"},
        {name: ">=", value: "gte"},
      ],
      maleComparisonValue: null,
      femaleComparisonValue: null,
    };
  },
  async beforeMount() {
    await this.fetchSummaryPreServices();
    await this.initateLookups();
    await this.fetchDetailPreServices();
  },
  watch: {
    options: {
      handler() {
        this.fetchDetailPreServices();
      },
      deep: true,
    },
    cat2options: {
      handler() {
        this.fetchSummaryPreServices();
      },
      deep: true,
    },
    cat2preServiceLevelValue: function (val) {
      this.cat2preServiceLevelValue = val;
      this.fetchSummaryPreServices();
    },
    cat2universityValue: function (val) {
      this.cat2universityValue = val;
      this.fetchSummaryPreServices();
    },
    cat2programValue: function (val) {
      this.cat2programValue = val == '' ? null : val;
      this.fetchOnFilters();
      this.fetchSummaryPreServices();
    },
    cat2disciplineValue: function (val) {
      this.cat2disciplineValue = val == '' ? null : val;
      this.fetchSummaryPreServices();
    },
    cat2yearOfEducValue: function (val) {
      this.cat2yearOfEducValue = val == '' ? null : val;
      this.fetchSummaryPreServices();
    },
    maleValue: function (val) {
      this.maleValue = val;
      this.fetchSummaryPreServices();
    },
    maleComparisonValue: function (val) {
      this.maleComparisonValue = val;
      this.fetchSummaryPreServices();
    },
    femaleValue: function (val) {
      this.femaleValue = val;
      this.fetchSummaryPreServices();
    },
    femaleComparisonValue: function (val) {
      this.femaleComparisonValue = val;
      this.fetchSummaryPreServices();
    },
    cat2StartDateValue: function (val) {
      this.cat2StartDateValue = val;
      this.fetchSummaryPreServices();
    },
    cat2EndDateValue: function (val) {
      this.cat2EndDateValue = val;
      this.fetchSummaryPreServices();
    },
    cat2DateRangePreset: function (val) {
      this.applyPresetWithSelection(val, "cat2StartDateValue", "cat2EndDateValue", "cat2DateRangeYear", "cat2DateRangePeriod");
    },
    cat2DateRangeYear: function () {
      if (this.cat2DateRangePreset) {
        this.applyPresetWithSelection(this.cat2DateRangePreset, "cat2StartDateValue", "cat2EndDateValue", "cat2DateRangeYear", "cat2DateRangePeriod");
      }
    },
    cat2DateRangePeriod: function () {
      if (this.cat2DateRangePreset) {
        this.applyPresetWithSelection(this.cat2DateRangePreset, "cat2StartDateValue", "cat2EndDateValue", "cat2DateRangeYear", "cat2DateRangePeriod");
      }
    },

    preServiceLevelValue: function (val) {
      this.preServiceLevelValue = val;
      this.fetchOnFilters();
      this.fetchDetailPreServices();
    },
    universityValue: function (val) {
      this.universityValue = val;
      this.fetchDetailPreServices();
    },
    levelOfStudyValue: function (val) {
      this.levelOfStudyValue = val;
      this.fetchDetailPreServices();
    },
    programValue: function (val) {
      this.programValue = val == '' ? null : val;
      this.fetchOnFilters();
      this.fetchDetailPreServices();
    },
    disciplineValue: function (val) {
      this.disciplineValue = val == '' ? null : val;
      this.fetchDetailPreServices();
    },
    yearOfEducValue: function (val) {
      this.yearOfEducValue = val == '' ? null : val;
      this.fetchDetailPreServices();
    },
    nameValue: function (val) {
      this.nameValue = val;
      this.fetchDetailPreServices();
    },
    sexValue: function (val) {
      this.sexValue = val == '' ? null : val;
      this.fetchDetailPreServices();
    },
    idNoValue: function (val) {
      this.idNoValue = val;
      this.fetchDetailPreServices();
    },
    departmentValue: function (val) {
      this.departmentValue = val;
      this.fetchDetailPreServices();
    },
    backgroundProfessionValue: function (val) {
      this.backgroundProfessionValue = val;
      this.fetchDetailPreServices();
    },
    nationalityValue: function (val) {
      this.nationalityValue = val;
      this.fetchDetailPreServices();
    },
    startDateValue: function (val) {
      this.startDateValue = val;
      this.fetchDetailPreServices();
    },
    endDateValue: function (val) {
      this.endDateValue = val;
      this.fetchDetailPreServices();
    },
    dateRangePreset: function (val) {
      this.applyPresetWithSelection(val, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
    },
    dateRangeYear: function () {
      if (this.dateRangePreset) {
        this.applyPresetWithSelection(this.dateRangePreset, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
      }
    },
    dateRangePeriod: function () {
      if (this.dateRangePreset) {
        this.applyPresetWithSelection(this.dateRangePreset, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
      }
    },
  },
  methods: {
    formatPreServiceLevel(value) {
      return value === "NimeiProgram" ? "Graduate Entry" : value;
    },
    getDisplayCumulativeGpa(status) {
      if (status?.cumulativeGpa != null && status?.cumulativeGpa !== "") {
        return status.cumulativeGpa;
      }

      return status?.gpa ?? "-";
    },
    formatStudentStatuses(statuses) {
      return (statuses || []).map((status) => {
        const year = status.yearOfEducation || "-";
        const studentStatus = status.studentStatus || "-";
        return `${year}(${studentStatus}, ${this.getDisplayCumulativeGpa(status)})`;
      }).join(", ");
    },
    async fetchOnFilters() {
      this.DISCIPLINES = this.allDisciplines
          .filter(x => x.educationProgramId == this.cat2programValue?.id ?? this.programValue.id);
      this.LEVEL_OF_STUDIES = this.LEVEL_OF_STUDIES.filter(x => x.level_type == this.preServiceLevelValue);
    },
    async initateLookups() {
      this.GENDERS = [{name: "Male"}, {name: "Female"}];
      this.PRE_SERVICE_LEVELS = EducLevelEnum.map((level) => ({
        ...level,
        displayName: level.code === "NIMEI" ? "Graduate Entry" : level.name,
      }));
      this.YEAR_OF_EDUCATION = await YearOfEducEnum.map(x => (x.name == '1st Year 1st Semester' ||
          x.name == '1st Year 2nd Semester') ? x.name = '1st Year' : x);

      this.lookupLoading = true;
      this.LEVEL_OF_STUDIES = await getLevelOfStudies();
      this.LEVEL_OF_STUDIES = this.LEVEL_OF_STUDIES.rows;
      this.allDisciplines = await getDisciplines();
      this.allDisciplines = this.allDisciplines.rows;
      this.EDUCATIONAL_PROGRAMS = await getEducationalPrograms()
      this.EDUCATIONAL_PROGRAMS = this.EDUCATIONAL_PROGRAMS.rows;
      const univResp = await getUniversities();
      const assignedUniversity = this.isUniversityScopedUser ? getAssignedUniversityOption() : null;
      this.UNIVERSITIES = (univResp.rows && univResp.rows.length > 0) ? univResp.rows.filter((data) => {
        return data.isActive === true || (assignedUniversity && Number(data.id) === Number(assignedUniversity.id));
      }) : null;
      if (this.isUniversityScopedUser) {
        if (assignedUniversity) {
          this.UNIVERSITIES = this.UNIVERSITIES?.filter((data) => Number(data.id) === Number(assignedUniversity.id)) || [assignedUniversity];
          this.universityValue = assignedUniversity;
          this.cat2universityValue = assignedUniversity;
        }
      }
      this.lookupLoading = false;
    },
    async fetchDetailPreServices() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;

      let searchParams = '?';
      itemsPerPage > 0 && (searchParams += `page=${page}&pageSize=${itemsPerPage}`);

      this.preServiceLevelValue !== null && (searchParams += '&preServiceLevel=' + this.preServiceLevelValue.replace(/\s/g, ''));
      this.universityValue !== null && (searchParams += '&universityId=' + this.universityValue.id);
      this.levelOfStudyValue !== null && (searchParams += '&levelOfStudyId=' + this.levelOfStudyValue.id);
      this.programValue !== null && (searchParams += '&educationProgramId=' + this.programValue.id);
      this.disciplineValue !== null && (searchParams += '&disciplineId=' + this.disciplineValue.id);
      this.yearOfEducValue !== null && (searchParams += '&entryYear=' + (this.currentYear - this.yearOfEducValue.id) ?? this.currentYear);
      this.nameValue !== null && (searchParams += '&name=' + this.nameValue);
      this.sexValue !== null && (searchParams += '&sex=' + this.sexValue);
      this.idNoValue !== null && (searchParams += '&idNo=' + this.idNoValue);
      this.departmentValue !== null && (searchParams += '&department=' + this.departmentValue);
      this.backgroundProfessionValue !== null && (searchParams += '&backgroundProfession=' + this.backgroundProfessionValue);
      this.nationalityValue !== null && (searchParams += '&nationality=' + this.nationalityValue);
      this.startDateValue !== null && (searchParams += '&startDate=' + this.startDateValue);
      this.endDateValue !== null && (searchParams += '&endDate=' + this.endDateValue);

      const res = await PreServiceReportService.getPreServices(searchParams);
      if (res.status === 200) {
        this.loading = false;
        this.preServiceDetailReports = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching pre service detail reports, Please try Again!"
        );
      }
    },
    async fetchSummaryPreServices() {
      this.cat2loading = true;
      const {page, itemsPerPage} = this.cat2options;

      let searchParams = '?';
      itemsPerPage > 0 && (searchParams += `page=${page}&pageSize=${itemsPerPage}`);

      this.cat2preServiceLevelValue !== null && (searchParams += '&preServiceLevel=' + this.cat2preServiceLevelValue.replace(/\s/g, ''));
      this.cat2universityValue !== null && (searchParams += '&universityId=' + this.cat2universityValue.id);
      this.cat2programValue !== null && (searchParams += '&educationProgramId=' + this.cat2programValue.id);
      this.maleValue !== null && (searchParams += '&noOfMale=' + this.maleValue);
      this.maleComparisonValue !== null && (searchParams += '&signMale=' + this.maleComparisonValue);
      this.femaleValue !== null && (searchParams += '&noOfFemale=' + this.femaleValue);
      this.femaleComparisonValue !== null && (searchParams += '&signFemale=' + this.femaleComparisonValue);
      this.cat2disciplineValue !== null && (searchParams += '&disciplineId=' + this.cat2disciplineValue.id);
      this.cat2yearOfEducValue !== null && (searchParams += '&entryYear=' + (this.currentYear - this.cat2yearOfEducValue.id) ?? this.currentYear);
      this.cat2StartDateValue !== null && (searchParams += '&startDate=' + this.cat2StartDateValue);
      this.cat2EndDateValue !== null && (searchParams += '&endDate=' + this.cat2EndDateValue);

      const res = await PreServiceReportService.getPreServiceSummary(searchParams);
      if (res) {
        this.cat2loading = false;
        this.preServiceSummaryReports = res;
      } else {
        this.cat2loading = false;
        this.$toast.error(
            "There was a problem fetching pre service summary reports, Please try Again!"
        );
      }
    },
  },
};
</script>
